import React, { useState } from "react";
import { CreditUnionHeroSection } from "./CreditUnionHeroSection";
import { CreditUnionStatsSection } from "./CreditUnionStatsSection";
import { CreditUnionSolutionSection } from "./CreditUnionSolutionSection";
import { CreditUnionMemberExperienceSection } from "./CreditUnionMemberExperienceSection";
import { CreditUnionBenefitsSection } from "./CreditUnionBenefitsSection";
import { CreditUnionGetStartedSection } from "./CreditUnionGetStartedSection";
import { CalculatorModal } from "@/components/ui/CalculatorModal";
import { CreditUnionCalculator } from "./CreditUnionCalculator";

export const CreditUnionsLayout: React.FC = () => {
  const [isCalcOpen, setIsCalcOpen] = useState(false);

  return (
    <>
      <CreditUnionHeroSection />
      <CreditUnionStatsSection onOpenCalc={() => setIsCalcOpen(true)} />
      <CreditUnionSolutionSection />
      <CreditUnionMemberExperienceSection />
      <CreditUnionBenefitsSection />
      <CreditUnionGetStartedSection />
      <CalculatorModal isOpen={isCalcOpen} onClose={() => setIsCalcOpen(false)}>
        <CreditUnionCalculator />
      </CalculatorModal>
    </>
  );
};
